import React from 'react';
import { images } from '../data/content';
import { CtaButton } from './CtaButton';
export function Creator() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-78" data-mp="26ccsunxxdpaj">
      <div className="mx-auto grid max-w-6xl items-start gap-10 px-4 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14" data-id="element-79" data-mp="229g5kjxfx509">
        <div className="lg:sticky lg:top-8" data-id="element-80" data-mp="1xan0nfw7ymbp">
          <img src={images.creator} alt="Dr. Nathan Brooks in a dental clinic" className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-[0_24px_60px_-30px_rgba(16,42,76,0.6)]" loading="lazy" data-id="element-81" data-mp="1x9v5u7ag4smh" />
        </div>

        <div data-id="element-82" data-mp="1imifm59p1ypr">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent sm:text-sm" data-id="element-83" data-mp="1im0bynkpci7t">About the Creator</p>
          <h2 className="mt-3 font-display text-4xl font-bold text-ink sm:text-5xl" data-id="element-84" data-mp="1ehsm2n2icw80">Dr. Nathan Brooks</h2>
          <p className="mt-2 text-base font-semibold text-muted" data-id="element-85" data-mp="19mvd1g58amv4">
            Periodontal & Dental Education — Creator of Third Molar Assessment Blueprint™
          </p>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-86" data-mp="21zld35r2bt08">
            <p data-id="element-87" data-mp="26s4ygovzrsfl">
              I created Third Molar Assessment Blueprint™ because I wanted to develop a more organized way to approach the information
              involved in third molar assessment.
            </p>
            <p data-id="element-88" data-mp="1xzb4rmfssqi7">
              In dentistry, we study anatomy, clinical examination, radiographic interpretation, patient history, anatomical relationships,
              potential complications, and treatment considerations.
            </p>
            <p className="font-semibold text-ink" data-id="element-89" data-mp="2bq6gr7llfnq0">Each area matters.</p>
            <p data-id="element-90" data-mp="2bpy6lnguuwii">
              But studying these subjects separately doesn’t always make it easy to connect them when reviewing a case or preparing a
              clinical discussion.
            </p>
            <p data-id="element-91" data-mp="109q0xd64n52m">That observation inspired me to develop this visual framework.</p>
            <p data-id="element-92" data-mp="15bp2qim7xtxg">
              I didn’t want to create another extensive textbook or a course filled with hours of lectures. I wanted to build a practical
              reference that brings related concepts together in one organized system.
            </p>
            <p data-id="element-93" data-mp="cffsbqe0ujjt">Something you can open, navigate, study, and revisit.</p>
            <p data-id="element-94" data-mp="cdcu4j2ptk40">
              My intention is not to replace your clinical education, professional experience, or judgment. It’s to give you another way
              to organize the information you already have, identify questions that need further review, and prepare more structured
              educational discussions.
            </p>
            <p data-id="element-95" data-mp="3plfz09iijnl8">
              I hope Third Molar Assessment Blueprint™ becomes a useful part of your professional learning and case-review process.
            </p>
            <p className="font-display text-xl font-bold italic text-navy" data-id="element-96" data-mp="3kphbsp8x8bme">— Dr. Nathan Brooks</p>
          </div>

          <div className="mt-8" data-id="element-97" data-mp="1iw1dd66ldsgv">
            <CtaButton label="I Want Dr. Brooks’ Assessment Framework" data-id="element-98" data-mp="1iwt5u84w7a2x" />
          </div>
        </div>
      </div>
    </section>;
}